// extracted by mini-css-extract-plugin
export var actionText = "_ov-4";
export var container = "_ov-0";
export var leftSection = "_ov-1";
export var rightSection = "_ov-2";
export var settingsButton = "_ov-6";
export var settingsIcon = "_ov-7";
export var shortcut = "_ov-5";
export var shortcutGroup = "_ov-3";